import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import {
  getDatabase,
  ref,
  onValue,
  off,
  push,
  set,
  update,
} from "firebase/database";

const firebaseConfig = {
  // Your Firebase config here
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const database = getDatabase(app);

// Real-time inventory listeners (using Firestore instead of Realtime Database for now)
export const inventoryListeners = {
  // Listen to stock movements
  onStockMovements: (restaurantId, callback) => {
    // For now, we'll use polling instead of real-time listeners
    // This can be enhanced later with Firestore onSnapshot
    const interval = setInterval(async () => {
      try {
        // This would need to be implemented with actual API call
        // For now, just return empty array
        callback([]);
      } catch (error) {
        console.error("Error fetching movements:", error);
        callback([]);
      }
    }, 5000); // Poll every 5 seconds

    return () => clearInterval(interval);
  },

  // Listen to inventory items
  onInventoryItems: (restaurantId, callback) => {
    // For now, we'll use polling instead of real-time listeners
    const interval = setInterval(async () => {
      try {
        // This would need to be implemented with actual API call
        // For now, just return empty array
        callback([]);
      } catch (error) {
        console.error("Error fetching items:", error);
        callback([]);
      }
    }, 5000); // Poll every 5 seconds

    return () => clearInterval(interval);
  },

  // Listen to low stock alerts
  onLowStockAlerts: (restaurantId, callback) => {
    // For now, we'll use polling instead of real-time listeners
    const interval = setInterval(async () => {
      try {
        // This would need to be implemented with actual API call
        // For now, just return empty array
        callback([]);
      } catch (error) {
        console.error("Error fetching alerts:", error);
        callback([]);
      }
    }, 5000); // Poll every 5 seconds

    return () => clearInterval(interval);
  },
};

// Real-time updates (placeholder for future implementation)
export const realtimeUpdates = {
  // Update stock movement in real-time
  updateStockMovement: async (restaurantId, movementId, data) => {
    // This would be implemented with actual API call
    console.log("Updating stock movement:", { restaurantId, movementId, data });
    return Promise.resolve();
  },

  // Update inventory item in real-time
  updateInventoryItem: async (restaurantId, itemId, data) => {
    // This would be implemented with actual API call
    console.log("Updating inventory item:", { restaurantId, itemId, data });
    return Promise.resolve();
  },

  // Create real-time alert
  createAlert: async (restaurantId, alertData) => {
    // This would be implemented with actual API call
    console.log("Creating alert:", { restaurantId, alertData });
    return Promise.resolve();
  },
};

// Helper to get Firebase ID token
export async function getCurrentIdToken() {
  const user = auth.currentUser;
  if (!user) throw new Error("User not logged in");
  return await user.getIdToken(/* forceRefresh */ true);
}

export { auth, db, database };
